import React, { useState, useEffect } from 'react';
import "./notice.css";
import { TfiAnnouncement } from "react-icons/tfi";
import NoticeItems from './NoticeItems';
import AnimatedSection from '../AnimatedSection';
import { Pagination, message } from 'antd';

const Notice = () => {
  const [notices, setNotices] = useState([]); // API'den gelen verileri saklayacağız
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 5;
  const apiUrl = process.env.REACT_APP_API_URL;

  
  useEffect(() => {
    const fetchNotices = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/api/notice`);
        if (response.ok) {
          let data = await response.json();
  
          data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  
          setNotices(data);
        } else {
          message.error("Duyurular yüklenemedi!");
        }
      } catch (error) {
        console.error("Veri çekme hatası:", error);
        message.error("Bağlantı hatası!");
      } finally {
        setLoading(false);
      }
    };
  
    fetchNotices();
  }, [apiUrl]);
  

  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = notices.slice(startIndex, startIndex + itemsPerPage);

  const truncateText = (text, length) => {
    return text.length > length ? `${text.slice(0, length)}...` : text;
  };

  return (
    <>
      <div className="notice-container">
        <div className="notice-page-bg">
          <AnimatedSection amount={1}>
            <div className="notice-page-bg-icon">
              <div className="icon-box">
                <TfiAnnouncement />
              </div>
            </div>
          </AnimatedSection>
        </div>
        <div className="notice-elements">
          <div className="notice-title">
            <h2>Haberler ve Duyurular</h2>
          </div>

          {loading ? (
            <p style={{ textAlign: "center", fontSize: "18px" }}>Yükleniyor...</p>
          ) : (
            <div className="card-wrap-notice">
              {currentData.length > 0 ? (
                currentData.map(item => (
                  <NoticeItems key={item.id} item={{ ...item, content: truncateText(item.content, 200) }} />
                ))
              ) : (
                <p style={{ textAlign: "center", fontSize: "18px" }}>Henüz duyuru bulunmamaktadır.</p>
              )}
            </div>
          )}
        </div>

        <div className="pagination">
          <Pagination 
            current={currentPage} 
            total={notices.length} 
            pageSize={itemsPerPage} 
            onChange={setCurrentPage} 
          />
        </div>
      </div>
    </>
  );
};

export default Notice;
